/**
 * RequestInterceptor
 * @module Services/http/RequestInterceptor
 * @description Returns a RequestInterceptor function that'll intercept every http request
 */

import AuthService from '../domain/AuthService';
import LinksProvider from './LinksProvider';

/**
 * Intercepts every http request and adds the jwt access token to the header
 * @author Sameh Bellez
 * @alias RequestInterceptor
 * @memberof module:Services/http/RequestInterceptor
 * @param   {object} config The request config
 * @returns {object}  The request config
 */
function RequestInterceptor(ctx) {
  return (config) => {
    if (config && typeof config.url === 'string' && !/^https?:\/\//i.test(config.url)) {
      config.baseURL = LinksProvider.getBackendBaseUrl();
    }
    config.keepOriginalResponse = config.headers['Keep-Original-Response'];
    // Ne pas fixer Content-Type si c'est un FormData
    if(!config.headers && !config.headers['Content-Type']){
      config.headers['Content-Type'] = 'application/json';
    }
    config.headers['Origin-App'] = 'M1L';
    AuthService.isAuthenticated()
    && (config.headers['Authorization'] = `Bearer ${AuthService.getToken()}`);
    (ctx && ctx.req)
    && (config.headers['Authorization'] = `Bearer ${AuthService.getServerToken(ctx)}`);
    (ctx && ctx.req && ctx.req.ip)
    && (config.headers['X-Client-Ip'] = ctx.req.ip);
    return config;
  };
}

export default RequestInterceptor;
